export function getBaseUrl() {
  return (
    window.location.protocol +
    "//" +
    window.location.hostname +
    (window.location.port ? ":" + window.location.port : "") +
    process.env.PUBLIC_URL
  );
}
